import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=aa9ff4e2&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9ff4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa9ff4e2')) {
      api.createRecord('aa9ff4e2', component.options)
    } else {
      api.reload('aa9ff4e2', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=aa9ff4e2&scoped=true&", function () {
      api.rerender('aa9ff4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports